import React, { useEffect, useState } from "react";
import Button from "../../../components/Buttons/Button";
import DataTable from "../../../components/DataTable/DataTable";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import BusinessPartnerModel from "../../../models/BusinessPartnerModel";
import BusinessPartnerReferenceModel from "../../../models/BusinessPartnerReferenceModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface ExportModel {
    businessPartnerId: number
    businessPartnerReferences: BusinessPartnerReferenceModel[]
}
interface IProps extends PopupProps {
    businessPartner: BusinessPartnerModel
}

const ExportBusinessPartnerPopup: React.FC<IProps> = ({ show, onHide, businessPartner }) => {
    const { handleResult, handleException } = useNotifications();
    const [data, setData] = useState<ExportModel>();

    useEffect(() => {
        getData()
    }, [businessPartner]);

    function getData() {
        if (businessPartner) {
            DataService.get<BusinessPartnerReferenceModel[]>('api/v1/BusinessPartnerReferences/ByBusinessPartnerForExport/' + businessPartner.id)
                .then(response => {
                    setData({
                        businessPartnerId: businessPartner.id,
                        businessPartnerReferences: response
                    })
                })
        }
    }

    function submit() {
        if (data) {
            data.businessPartnerReferences = data.businessPartnerReferences.filter(x => x['_checkbox_export'] === true)
            DataService
                .post<Result>(`api/v1/BusinessPartnerReferences/export`, data)
                .then(response => {
                    handleResult(response);
                    if (response.isSuccesful === true)
                        onHide();
                    else
                        getData();
                })
                .catch(e => handleException(e));
        }
    }

    function selectAllRows(selectedRows: any[]) {
        if (data) {
            if (selectedRows.length != data.businessPartnerReferences.length)
                data.businessPartnerReferences.forEach(r => r['_checkbox_export'] = true)
            else
                data.businessPartnerReferences.forEach(r => r['_checkbox_export'] = false)

            setData(x => ({ ...data }))
        }
    }

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Export business-partner'} >
            <Popup.Body>
                {data && (
                    <DataTable
                        name='dtBusinessPartnerExport'
                        colInfos={[
                            { key: true, dataProp: 'id', visible: false },
                            { checkboxButton: { icon: 'fa-check', color: 'green', text: 'export', onClick: (selectedRows) => { selectAllRows(selectedRows); } } },
                            { title: 'External System', dataProp: 'externalSystemName' },
                            { title: 'Reference code', dataProp: 'referenceCode' },
                            { title: 'Ready on', dataProp: 'readyForExportOn', dataType: 'datetime' },
                            { title: 'Exported on', dataProp: 'exportedOn', dataType: 'datetime' },
                        ]}
                        tableData={data.businessPartnerReferences}
                    />
                )}
            </Popup.Body>
            <Popup.Footer>
                <Button text="Export" type='button' onClick={submit} />
            </Popup.Footer>
        </Popup>
    );
}
export default ExportBusinessPartnerPopup;